// extracted by mini-css-extract-plugin
export default {"bannerCarousel":"BannerCarousel_bannerCarousel__HKAnw","swiper":"BannerCarousel_swiper__Q7etr"};